export default "/images/5055db6aea7de4c7658d8ad6c6e228b1.avif";